// METHODS

function scrollCallbackForBG(AnimationInstance, elClass, divideRatio = 800) {
  let el = $(elClass);
  return () => {
    let scrollOffset = window.pageYOffset || window.scrollTop;
    let elOffset = el.offset().top - window.innerHeight;

    let readyScroll = scrollOffset - elOffset;
    if (readyScroll > 0) {
      let scrollDivided = readyScroll / (divideRatio + window.innerHeight);
      AnimationInstance.seek(AnimationInstance.duration * scrollDivided);
    }
  };
}

function scrollOnVisibilityAnimate(callback, el, threshold = 0.5) {
  let observer = new IntersectionObserver(
    (entry) => {
      if (entry?.[0]?.isIntersecting) {
        callback();
        observer.unobserve(el);
      }
    },
    {
      rootMargin: "0px",
      threshold,
    }
  );

  observer.observe(el);
}

// INIT CALLBACK SCOPE

$(() => {
  new LazyLoad({
    use_native: true,
  });

  setContactListener();

  scrollOnVisibilityAnimate(
    () => {
      anime({
        targets: ".case-study",
        opacity: ["0%", "100%"],
        translateY: ["40px", "0"],
        easing: "easeInOutQuad",
        duration: 800,
        delay: anime.stagger(400),
      });
    },
    document.querySelector(".section-case-studies__container"),
    0.4
  );

  let scrollCallbackFooterNet = scrollCallbackForBG(
    anime({
      targets: ".bg-graphic--footer img",
      translateY: 120,
      autoplay: false,
      easing: "linear",
    }),
    ".navigation-footer",
    window.innerHeight
  );

  // HERO animations
  anime({
    targets: ".onload-animate-in",
    opacity: ["0%", "100%"],
    translateY: ["-10px", "0"],
    easing: "easeInOutQuad",
    duration: 600,
    delay: anime.stagger(200, { start: 100 }),
  });
  let tabs = document.querySelectorAll(".process__tab");
  let tabsContent = document.querySelectorAll(".process__content");

  document
    .querySelector(".process__tab-container")
    .addEventListener("click", (e) => {
      let clicked = e.target.closest(".process__tab");

      // ⭐️ Guard clause ⭐️ //
      if (!clicked) return;

      tabs.forEach((t) => t.classList.remove("process__tab--active"));
      clicked.classList.add("process__tab--active");

      // ⭐️ Activate content area ⭐️ //
      tabsContent.forEach((tc) =>
        tc.classList.remove("process__content--active")
      );
      document
        .querySelector(`.process__content--${clicked.dataset.tab}`)
        .classList.add("process__content--active");

      // ⭐️ Place hash in the URL ⭐️ //
      location.hash = clicked.dataset.hash;
    });

  // Set it up on init

  let activeHash = location.hash.replace("#", "");
  if (
    activeHash &&
    ["project-vision", "approach", "outcomes"].includes(activeHash)
  ) {
    $(".process__tab-container button").each((tc) => {
      $(".process__tab").each((t) => $(t).removeClass("process__tab--active"));
      $(".process__content").each((t) =>
        $(t).removeClass("process__content--active")
      );

      if (activeHash === tc.dataset.hash) {
        setTimeout(() => {
          $(`.process__tab--${tc.dataset.tab}`).addClass(
            "process__tab--active"
          );
          $(`.process__content--${tc.dataset.tab}`).addClass(
            "process__content--active"
          );
        }, 500);
      }
    });
  }

  scrollCallbackFooterNet();

  $(window).on(
    "scroll",
    requestAnimationFrame.bind(null, () => {
      scrollCallbackFooterNet();
    })
  );
});
